import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {ReactiveService} from '../reactive-service.abstract';
import {ActivatedRoute, ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {BehaviorSubject, Observable} from 'rxjs';
import {FavoriteModel, FavoriteType} from './favorite.model';


export interface IFavoriteObject {
  type: FavoriteType;
  id?: string;
  title?: string;
}

@Injectable()
export class FavoritesApiService extends ReactiveService implements Resolve<FavoriteModel> {

  private baseUrl = '/db/user/profile/favorites';

  currentUrl = '';

  _favorite = new BehaviorSubject<IFavoriteObject>({type: FavoriteType.URL});
  get favorite() {
    return this._favorite.asObservable();
  }

  constructor(private http: HttpClient, private route: ActivatedRoute) {
    super();
  }

  create(data: Omit<FavoriteModel, 'id'>): Observable<FavoriteModel> {
    return this.http.post<FavoriteModel>(`${this.baseUrl}`, data);
  }

  delete(linkId: number) {
    return this.http.delete(`${this.baseUrl}/${linkId}`, {params: {}});
  }

  save(linkId: number, data: Omit<FavoriteModel, 'id'>): Observable<FavoriteModel> {
    return this.http.put<FavoriteModel>(`${this.baseUrl}/${linkId}`, data);
  }

  get(linkId: number): Observable<FavoriteModel> {
    return this.http.get<FavoriteModel>(`${this.baseUrl}/${linkId}`);
  }

  getAll(linkType?: string): Observable<FavoriteModel[]> {
    if (linkType) {
      return this.http.get<FavoriteModel[]>(`${this.baseUrl}`, {params: {'linktype':linkType}});
    }
    return this.http.get<FavoriteModel[]>(`${this.baseUrl}`);
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<FavoriteModel> | Promise<FavoriteModel> | FavoriteModel {
    return this.get(route.params.linkId);
  }

  setFavoriteObject(obj: IFavoriteObject = {type: FavoriteType.URL}) {
    if (this.currentUrl !== window.location.href || obj.type !== FavoriteType.URL) {
      this.currentUrl = window.location.href;
      this._favorite.next(obj);
    }
  }


}
